import { render, staticRenderFns } from "./ThesisEdit.vue?vue&type=template&id=b6c88b10"
import script from "./ThesisEdit.vue?vue&type=script&lang=js"
export * from "./ThesisEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports